import { useCompositionAdvancedOptionsContext } from 'features/compositions/context/CompositionAdvancedOptionsContext';
import { useCompositionsContext } from 'features/compositions/context/CompositionsContext';
import { useReadComposition } from 'features/compositions/services/useReadComposition';
import styles from './FilterActions.module.css';

const FilterActions = () => {
  const { resetFilters, query, sortBy, setPage } = useCompositionAdvancedOptionsContext();
  const { selectedComposition } = useCompositionsContext();
  const { readComposition, loading } = useReadComposition();

  const handleApplyFilters = () => {
    if (!selectedComposition?.name || loading) return;
    setPage(1);
    readComposition({
      composition: selectedComposition.name,
    });
  };

  return (
    <div className={styles.filter_actions}>
      <button type="button" onClick={resetFilters} disabled={loading}>
        Reset filters
      </button>
      <button type="button" onClick={handleApplyFilters} disabled={loading}>
        {loading ? 'Applying...' : 'Apply filters'}
      </button>
    </div>
  );
};

export default FilterActions;
